<template>
  <!-- 头部 -->
  <div class="formGroup" v-loading.fullscreen="loading" element-loading-text="加载中">
    <div class="search-banner">
      <div class="mynav">
        <img src="../assets/img/logo_ZH.png" alt="Zata搜索" class="logo" @click="toIndex">
        <div class="search-box">
          <el-input @keyup.13.native="handleSearch" @click.stop.native="showList" maxlength="200" v-model="keywords"
            class="input-with-select">
            <el-select @change="changeKey" v-model="keywordsType" slot="prepend" placeholder="请选择">
              <el-option label="文献搜索" value="normal"></el-option>
              <el-option label="病例搜索" value="patient"></el-option>
              <el-option label="研究搜索" value="clinical"></el-option>
              <el-option label="药品搜索" value="drug"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click.stop="handleSearch"></el-button>
          </el-input>
          <div class="searchList" v-show="showHisList">
            <ul v-if="hisList.length !== 0">
              <li class="clearfix" v-for="(item, index) in hisList" :key="index">
                <span class="L" @click="chooseHisKey(item.keyword)">{{
                  item.keyword
                }}</span>
                <i class="el-icon-delete R" @click.prevent="deleteHis(item.keyword, item.id)"></i>
              </li>
            </ul>
            <ul v-if="hisList.length === 0">
              <li class="clearfix"><span class="L">暂无历史记录</span></li>
            </ul>
          </div>
        </div>
        <div class="clearfix info">
          <!-- <span class="myCollection L" @click="handleCollection"><i class="el-icon-star-off"></i></span> -->
          <el-dropdown trigger="click" class="clearfix" @command="handleCommand">
            <img :src="headImg" alt="" class="headimg L">
            <el-badge class="item L username">{{ userName }}</el-badge>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="myCollection">我的收藏</el-dropdown-item> -->
              <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <img class="level" v-if="isVip == 1" src="../assets/img/vip1.png" alt="">
          <img class="level" v-if="isVip == 2" src="../assets/img/vip2.png" alt="">
        </div>
      </div>
    </div>
    <div class="iconList">
      <p>
        <el-popover placement="left" title="" width="80" trigger="hover" content="我的收藏">
          <img class="icon" src="../assets/img/icon/collect.png" alt="" slot="reference" @click="handleCollection">
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="80" trigger="hover" content="e药伴官网">
          <img class="icon" src="../assets/img/icon/icon1.png" alt="" slot="reference" @click="showIndex">
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="162" trigger="hover">
          <img src="../assets/img/icon/icon6.png" alt="">
          <span>e药伴介绍，扫一扫查看</span>
          <img class="icon" src="../assets/img/icon/icon3.png" alt="" slot="reference">
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="162" trigger="hover">
          <img src="../assets/img/icon/icon7.png" alt="">
          <span>微信扫一扫，手机用文献</span>
          <img class="icon" src="../assets/img/icon/icon2.png" alt="" slot="reference">
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="40" trigger="hover" content="首页">
          <img class="icon" src="../assets/img/icon/icon4.png" alt="" slot="reference" @click="toIndex">
        </el-popover>
      </p>
      <p v-show="backTop">
        <el-popover placement="left" title="" width="40" trigger="hover" content="顶部">
          <img class="icon" src="../assets/img/icon/icon5.png" alt="" slot="reference" @click="backToTop">
        </el-popover>
      </p>
    </div>
    <!-- <img src="../assets/img/home.png" alt="" class="goHome" @click="toIndex"> -->
  </div>
</template>

<script>
import { getRole, getUserVip } from "../service/getData";
import dayjs from 'dayjs'
import { baseHistory } from "../service/getData"
import { webTrackerEvent } from "../utils/tracker"
export default {
  name: 'viewHeader',
  data() {
    return {
      loading: false,
      headImg: '',
      userName: '',
      select: '',
      input3: '',
      backTop: false,
      scrollTop: 0,
      isVip: undefined,
      keywords: '',
      keywordsType: 'normal',
      showHisList: false, // 历史搜索
      hisList: [],
      pageNum: 1,
      pageSize: 10,
      searchTypeList: ['normal', 'drug', 'clinical', 'patient']
    }
  },
  methods: {
    handleSearch() {
      if (this.keywords === "") {
        this.$alert("请输入要搜索的关键字", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "search");
      Logger.push("token", this.token);
      Logger.push("search_keyword", this.keywords);
      Logger.push("search_kind", this.keywordsType == 'drug' ? 'medical' : this.keywordsType);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (this.keywordsType === "normal") {
        this.$router.push("/baseResult?key=" + encodeURIComponent(this.keywords) + "&searchType=" + this.keywordsType);
      } else if (this.keywordsType === "patient") {
        this.$router.push("/caseList?key=" + encodeURIComponent(this.keywords) + "&searchType=" + this.keywordsType);
      } else if(this.keywordsType === "clinical") {
        this.$router.push("clinicalTrials?key=" + encodeURIComponent(this.keywords) + "&searchType=" + this.keywordsType);
      } else {
        let type = this.keywordsType == 'drug' ? 'medical' : this.keywordsType;
        this.$router.push("/knowledge?key=" + encodeURIComponent(this.keywords) + "&searchType=" + type);
      }
    },
    changeKey() {
      this.keywords = '';
      this.hisList = [];
      this.getNormalSearch();
    },
    // 选择历史记录
    chooseHisKey(key) {
      if (key === "暂无历史记录") {
        return;
      }
      this.keywords = key;
    },
    showList() {
      this.showHisList = true;
    },
    // 获取基本历史记录
    async getNormalSearch() {
      const params = {
        type: this.keywordsType,
        limit: this.pageSize,
        page: this.pageNum,
      };
      const res = await baseHistory("GET", params);
      if (res && res.data.status === 0) {
        this.hisList = res.data.data;
      } else {
        this.hisList = [];
      }
    },
    // 删除历史记录
    async deleteHis(keyword, id) {
      const params = { type: this.search_type, id: id };
      const res = await baseHistory("DELETE", params);
      if (res && res.data.status === 0) {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "delete");
        Logger.push("delete_keyword", keyword);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
      }
    },
    // 计算滚动距离
    scrollToTop() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      if (scrollTop > 200) {
        this.backTop = true
      } else {
        this.backTop = false
      }
    },
    // 回到顶部
    backToTop() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed
        if (this.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    showIndex() {
      window.open('http://www.eyaoban.com/')
    },
    async weixinRedirect() {
      // 从本地拿到头像和昵称
      this.userName = window.localStorage.getItem('PUMMEDSEARCHUSERNAME');
      this.headImg = window.localStorage.getItem('PUMMEDSEARCHHEADIMG');
    },
    toIndex() {
      this.$router.push('/')
    },
    handleCommand(val) {
      this.loginout()
    },
    handleCollection() {
      this.$router.push('collection')
    },
    // 退出登录
    loginout() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        window.localStorage.clear()
        window.localStorage.setItem('REDIRECT', window.location.href);
        this.$router.push('login')
      }, 2000)
    },
    // 获取用户角色
    async getUserRole() {
      const res = await getRole();
      if (res && res.data.status === 0) {
        // this.isVip = Number(res.data.data["is_vip"]);
        // window.localStorage.setItem("ISVIP", res.data.data["is_vip"]);
        window.localStorage.setItem("ISADMIN", res.data.data["is_admin"]);
        window.localStorage.setItem("ISEDITOR", res.data.data["is_editor"]);
      }
    },
    /**
     * 获取个人vip等级
     */
    async handleGetVip() {
      let res = await getUserVip();
      let { status, data } = res.data;
      if (status == 0) {
        let { vip2 } = data;
        let isVip = 1;// 默认1，最低级
        if (vip2) {
          let ifBefore = dayjs().isBefore(dayjs(vip2).add(1, 'day'), 'day');
          if (ifBefore) {
            isVip = 2;
          }
        }
        this.isVip = isVip;
        window.localStorage.setItem("ISVIP", isVip);
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
    this.weixinRedirect();
    let isVip = window.localStorage.getItem('ISVIP');
    if (isVip) {
      this.isVip = Number(isVip);
    } else {
      this.getUserRole();
      this.handleGetVip();
    }
  },
  created() {
    let { key, searchType } = this.$route.query;
    this.keywords = key;
    if (searchType) {
      let type = searchType == 'medical' ? 'drug' : searchType;
      if (this.searchTypeList.includes(type)) {
        this.keywordsType = type
      } else {
        this.keywordsType = 'normal'
      }
    } else {
      this.keywordsType = 'normal'
    }
    this.getNormalSearch();
    const _this = this;
    document.addEventListener("click", function () {
      _this.showHisList = false;
    });
  }
}
</script>

<style scoped lang="less">
.formGroup {
  width: 100%;
  min-width: 1280px;
  margin: 0 auto;
}

.search-banner {
  width: 100%;
  background: url('../assets/pubmedSearch/back3.svg') no-repeat;
  background-size: cover;
}

.mynav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 40px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
}

.mynav span.myCollection {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 50%;
  display: block;
  margin-right: 40px;
  font-size: 28px;
  text-align: center;
  line-height: 36px;
  color: #FFA300;
  margin-top: 5px;
  cursor: pointer;
}

.info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.info .level {
  margin-left: 20px;
}

.mynav .logo {
  width: 104px;
  cursor: pointer;
}
.mynav .el-dropdown{
  display: flex;
  align-items: center;
}
.mynav .headimg {
  width: 36px;
  border-radius: 50%;
}

.mynav .username {
  font-size: 16px;
  margin-left: 10px;
  color: #fff;
  line-height: 50px;
}

.iconList {
  z-index: 11;
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translate(0, -50%);
}

.iconList .icon {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.goHome {
  width: 46px;
  height: 46px;
  position: fixed;
  bottom: 100px;
  right: 100px;
  cursor: pointer;
}

.mynav {
  /deep/.search-box {
    // width: 340px;
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    height: 36px;
    color: #fff;
    position: relative;

    .el-select {
      width: 130px;

      input {
        width: 100%;
      }
    }

    .el-input__icon {
      color: #fff;
      line-height: 36px;
    }

    .el-input__inner {
      // width: 250px;
      background: none;
      border: none;
      color: #fff;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      background: none;
      border: none;
      color: #fff;
    }

    .el-input-group__prepend {
      border-right: 1px solid rgba(255, 255, 255, 0.3);
    }
  }

  .searchList {
    position: absolute;
    top: 48px;
    left: 129px;
    z-index: 1;
    width: 320px;
    border-radius: 5px;
    background: #fff;
    padding: 10px;
    max-height: 200px;
    overflow: auto;
    border: 1px solid #E4E7ED;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

    ul li {
      font-size: 14px;
      color: #333;
      margin-bottom: 5px;
      padding: 5px;
      cursor: pointer;

      &:hover {
        color: #3491FA;
      }

      span {
        width: 80%;
        height: 100%;
      }
    }
  }
}
</style>
<style>
.el-popover {
  min-width: 40px !important;
  padding: 10px !important;
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/views/viewHeader.vue